import {defineNuxtPlugin} from '@nuxtjs/composition-api';
import { Plugin } from '@nuxt/types'
import VueShepherd from 'vue-shepherd';
import Shepherd from 'shepherd.js';
interface TourOptions {
    confirmCancel?: boolean
    confirmCancelMessage?: string
    classPrefix?: string
    defaultStepOptions?: StepOptions
    exitOnEsc?: boolean
    keyboardNavigation?: boolean
    stepsContainer?: HTMLElement
    modalContainer?: HTMLElement
    steps?: Array<Step>
    tourName?: string
    useModalOverlay?: boolean
}
interface Tour {
    addStep?: (options, index) => Step,
    addSteps?(steps: Array<Step>)
    back?()
    cancel?()
    complete?()
    getById?(id): Step
    getCurrentStep?(): Step|null
    hide?()
    isActive?(): boolean
    next?()
    removeStep?(name: string)
    show?(key: string|number, forward: boolean)
    start?()
}
interface StepOptions {
    arrow?: boolean,
    attachTo?: {element: string | HTMLElement , on: string},
    advanceOn?: any,
    beforeShowPromise?: (...args) => Promise<any>,
    buttons?: Array<{action: () => void, classes: string, disabled: boolean, label: string, secondary: boolean, text: string}>,
    canClickTarget?: boolean,
    cancelIcon?: {enabled?: boolean, label?: string},
    classes?: string,
    highlightClass?: string,
    id?: string,
    modalOverlayOpeningPadding?: number,
    modalOverlayOpeningRadius?: number,
    popperOptions: any,
    scrollTo?: boolean | {behavior: string, block: string},
    scrollToHandler?: () => void,
    showOn?: () => boolean,
    text: string,
    title: string,
    when?: {
        show?: () => void,
        hide?: () => void,
    }
}
interface Step{
    cancel(),
    complete(),
    destroy()
    getElement: () => HTMLElement|null|undefined
    getTarget: () => HTMLElement|null|undefined
    getTour: () => Tour
    hide()
    isCentered: () => boolean
    isOpen: () => boolean
    show()
    updateStepOptions(options: StepOptions)
}
interface ShepardOptions {
    confirmCancel?: boolean,
    confirmCancelMessage?: string,
    classPrefix?: string,
    defaultStepOptions?: StepOptions,
    exitOnEsc?: boolean,
    keyboardNavigation?: boolean,
    stepsContainer?: HTMLElement,
    modalContainer?: HTMLElement,
    steps?: Array<any> | Array<Step>,
    tourName?: string,
    useModalOverlay?: boolean,

}

export default defineNuxtPlugin((ctx, inject) => {
    inject('shepard', (options: Shepherd.Tour.TourOptions) => {
        return new Shepherd.Tour(options);
    })
    return VueShepherd;
})

declare module 'vue/types/vue' {
  // this.$myInjectedFunction inside Vue components
  interface Vue {
    $shepard(options: Shepherd.Tour.TourOptions): Shepherd.Tour
  }
}
declare module '@nuxt/types' {
  // nuxtContext.app.$myInjectedFunction inside asyncData, fetch, plugins, middleware, nuxtServerInit
  interface NuxtAppOptions {
    $shepard(options: Shepherd.Tour.TourOptions): Shepherd.Tour
  }
  // nuxtContext.$myInjectedFunction
  interface Context {
    $shepard(options: Shepherd.Tour.TourOptions): Shepherd.Tour
  }
}